import React from 'react'
import styles from './Heart.scss'
import { Icon } from 'common/Icon'
import { useFormatMessage } from 'lib/localization'
import cx from 'classnames'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  like: {
    id: 'Heart.like',
    defaultMessage: 'like'
  },
  liked: {
    id: 'Heart.liked',
    defaultMessage: 'liked'
  },
  likeReport: {
    id: 'Heart.likeReport',
    defaultMessage: 'like report'
  },
  unlike: {
    id: 'Heart.unlike',
    defaultMessage: 'unlike report'
  }
})

export const Heart = ({ liked, count, onClick }) => {
  const fm = useFormatMessage()
  return <div className={styles.Heart} onClick={onClick}>
    <Icon
      className={cx(styles.heartIcon, liked && styles.liked)}
      i={liked ? 'md-heart' : 'md-heart-outline'} size={24}
      title={fm(liked ? messages.unlike : messages.likeReport)} />
    {count && count > 0
      ? <div className={styles.count}>{count}</div>
      : <a className={styles.likeText}>{fm(liked ? messages.liked : messages.like)}</a>
    }
  </div>
}

// we are going to make the Heart not float to the left, and once we do that
// this can be removed.
export const HeartClickTarget = ({ onClick }) => (
  <div className={cx(styles.Heart, styles.HeartClickTarget)} onClick={onClick} />
)
